import React from 'react';

import "./Spotlight.css";

export default function Spotlight(props) {
  return <div className="portfolio-spotlight">
    <a name="spotlight" />
    <a href="https://demarestmedia.github.io/">
      <div className="clicker">
      </div>
    </a>
    <a href="#mdl-calc">
      <button className="portfolio-fab mdl-button mdl-button--colored mdl-js-button mdl-button--fab mdl-js-ripple-effect">
        <i className="material-icons">expand_more</i>
      </button>
    </a>
  </div>
}



// WEBPACK FOOTER //
// ./src/Pages/Spotlight/Spotlight.js